function ServiceShortcutCard({
  icon = "🔧",
  title,
  subtitle = "",
  tags = [],
  onClick,
}) {
  return (
    <button onClick={onClick} style={card} className="service-shortcut-card">
      <div style={iconStyle} className="service-shortcut-card__icon">{icon}</div>
      <div style={titleStyle} className="service-shortcut-card__title">{title}</div>
      {subtitle ? <div style={subtitleStyle} className="service-shortcut-card__subtitle">{subtitle}</div> : null}
      {tags.length > 0 ? (
        <div style={tagRow} className="service-shortcut-card__tags">
          {tags.slice(0, 2).map((tag) => (
            <div key={tag} style={tagPill}>
              {tag}
            </div>
          ))}
        </div>
      ) : null}
    </button>
  );
}

const card = {
  border: "1px solid #222",
  background: "#111",
  borderRadius: "16px",
  padding: "16px 12px",
  cursor: "pointer",
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
  minHeight: "170px",
  justifyContent: "flex-start",
  textAlign: "center",
};

const iconStyle = {
  fontSize: "26px",
  lineHeight: 1,
};

const titleStyle = {
  fontSize: "14px",
  fontWeight: "bold",
  textAlign: "center",
  lineHeight: "1.45",
};

const subtitleStyle = {
  fontSize: "12px",
  lineHeight: "1.5",
  color: "#b8b8b8",
};

const tagRow = {
  display: "flex",
  gap: "6px",
  flexWrap: "wrap",
  justifyContent: "center",
  marginTop: "2px",
};

const tagPill = {
  fontSize: "11px",
  color: "#d6d6d6",
  border: "1px solid #2b2b2b",
  background: "#0b0b0b",
  borderRadius: "999px",
  padding: "4px 8px",
};

export default ServiceShortcutCard;
